'use strict';

angular.module('ClinicApp').directive('clinicPaymentMethod', function($q, OCStringUtil, OpencareConstants, UserService, CurrentUser) {
  return {
    restrict: 'A',
    templateUrl: '/views/directives/_clinic-payment-method.html',
    scope: {
      clinic: '=clinicPaymentMethod',
      paymentMethods: '=',
      onCancel: '&',
      onSubmit: '&',
    },
    link: function($scope) {
      const CARD_NUMBER_MIN_LENGTH = 14;
      const CARD_NUMBER_MAX_LENGTH = 19;

      const bankAccountsEnabled = OCStringUtil.isUnitedStates($scope.clinic.address.country);
      let plaidLinkInstance; // https://plaid.com/docs/link/web/

      $scope.PAYMENT_METHOD_TYPE = OpencareConstants.paymentMethod.type;

      $scope.cards = $scope.paymentMethods.filter((paymentMethod) => {
        return paymentMethod.stripeObject === OpencareConstants.paymentMethod.type.CARD;
      });
      $scope.bankAccounts = $scope.paymentMethods.filter((paymentMethod) => {
        return paymentMethod.stripeObject === OpencareConstants.paymentMethod.type.BANK_ACCOUNT;
      });

      $scope.paymentMethodTypeOptions = [{
        value: OpencareConstants.paymentMethod.type.CARD,
        name: 'Credit or debit card',
        description: 'All major credit and debit cards are accepted.',
      }, {
        value: OpencareConstants.paymentMethod.type.BANK_ACCOUNT,
        name: 'Bank account',
        description: 'Only certain US banks are currently supported.',
        disabled: !bankAccountsEnabled,
      }];

      $scope.values = {
        // Select the card type by default if the bank accounts are not supported.
        paymentMethodType: !bankAccountsEnabled ? OpencareConstants.paymentMethod.type.CARD : null,
      };

      $scope.submitting = false;

      $scope.$watch('values.paymentMethodType', () => {
        resetValues();
      });

      $scope.resetForm = (form) => {
        form.$submitted = false;
        form.$setPristine();
      };

      $scope.selectPaymentMethodType = (value, form) => {
        $scope.values.paymentMethodType = value;
        $scope.resetForm(form);
      };

      $scope.cancel = () => {
        $scope.onCancel();
      };

      $scope.submit = (form) => {
        form.$submitted = true;

        const paymentMethodType = $scope.values.paymentMethodType;
        const paymentMethodData = {
          // ID of the existing payment method from the dropdown.
          id: parseInt($scope.values.id, 10) || undefined,
        };

        if (!paymentMethodData.id) {
          if (paymentMethodType !== OpencareConstants.paymentMethod.type.CARD) {
            return $q.reject();
          }

          paymentMethodData.number = parseCardNumber($scope.values.number);
          paymentMethodData.holderName = $scope.values.holderName || undefined;
          paymentMethodData.securityCode = $scope.values.securityCode || undefined;
          paymentMethodData.expMonth = $scope.values.expMonth;
          paymentMethodData.expYear = $scope.values.expYear;

          if (form.cardNumber) {
            form.cardNumber.$invalid = !paymentMethodData.number;
          }
        }

        if (form.$invalid) {
          return $q.reject();
        }

        $scope.submitting = true;

        return $q.when()
          .then(() => {
            return $scope.onSubmit({
              type: paymentMethodType,
              data: paymentMethodData,
            });
          })
          .finally(() => {
            $scope.submitting = false;
          });
      };

      $scope.addBankAccount = () => {
        if (!bankAccountsEnabled || !plaidLinkInstance || $scope.submitting) {
          return $q.reject();
        }

        $scope.submitting = true;
        plaidLinkInstance.open();
      };

      function resetValues() {
        if ($scope.values.paymentMethodType === OpencareConstants.paymentMethod.type.CARD) {
          $scope.values.id = $scope.cards.length === 0 ? '0' : null;
          const valuesToDelete = ['number', 'holderName', 'expMonth', 'expYear', 'securityCode'];

          for (const valueToDelete of valuesToDelete) {
            delete $scope.values[valueToDelete];
          }
        } else if ($scope.values.paymentMethodType === OpencareConstants.paymentMethod.type.BANK_ACCOUNT) {
          $scope.values.id = $scope.bankAccounts.length === 0 ? '0' : null;
        }
      }

      function parseCardNumber(cardNumberRaw) {
        const cardNumber = (cardNumberRaw || '').replace(/\D/g, '');

        if (cardNumber.length >= CARD_NUMBER_MIN_LENGTH && cardNumber.length <= CARD_NUMBER_MAX_LENGTH) {
          return cardNumber;
        }
      }

      function setupPlaid() {
        const onSuccess = (publicToken, metadata) => {
          UserService.createBankAccountFromPlaid(CurrentUser.getUserId(), publicToken, metadata.account_id)
            .then((bankAccount) => {
              return $scope.onSubmit({
                type: OpencareConstants.paymentMethod.type.BANK_ACCOUNT,
                data: {
                  id: bankAccount.id,
                },
              });
            })
            .finally(() => {
              $scope.$apply(() => {
                $scope.submitting = false;
              });
            });
        };

        const onExit = () => {
          $scope.$apply(() => {
            $scope.submitting = false;
          });
        };

        return UserService.getPlaidLinkInstance(CurrentUser.getUserId(), onSuccess, onExit)
          .then((_plaidLinkInstance) => {
            plaidLinkInstance = _plaidLinkInstance;
          });
      }

      resetValues();

      if (bankAccountsEnabled) {
        setupPlaid();
      }
    },
  };
});
